import { IGroupChatData, PATIENT_STATUS } from "@home-health-notify/domain";
import {
  HealthAndSafety,
  LocalOffer,
  MedicalServices,
} from "@mui/icons-material";
import { Box } from "@mui/material";
import { formatChatListDate, useTranslation } from "hhn-commons";
import PatientStatusImage from "../../../common/PatientStatusImage";
import { GROUP_AVATAR_SIZE } from "../../../utils/AvatarUtils";
import { PatientDetail } from "./PatientDetail";
import { StatusImgOutline } from "./PatientGroupChatListItem.style";
import PatientTitle from "./PatientTitle";
import { PendingReferralsDetail } from "./PendingReferralsDetail";
import ServicesToPatient from "./ServicesToPatient";
import { SocScheduleDate } from "./SocScheduleDate";

const PatientMoreContent = ({ chatData }: { chatData: IGroupChatData }) => {
  const status = chatData.groupInfo.patientStatus;
  const socDate = chatData.groupInfo.socScheduledOn;
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  return (
    <>
      <StatusImgOutline>
        <PatientStatusImage
          status={status}
          size={GROUP_AVATAR_SIZE.SMALL}
          testId="status-img"
        />
      </StatusImgOutline>
      <Box
        sx={{
          flexDirection: "column",
          display: "flex",
          marginLeft: "7px",
        }}
      >
        <PatientTitle
          title={chatData.groupInfo.name}
          mrn={chatData.groupInfo.mrn}
        />
        <ServicesToPatient
          servicesToPatient={chatData.groupInfo.servicesToPatient}
        />
        {socDate && String(status) === PATIENT_STATUS.PENDING_SOC && (
          <SocScheduleDate date={formatChatListDate(socDate)} />
        )}
        <PatientDetail
          title={tNs("patientTagLabel")}
          icon={<LocalOffer />}
          text={chatData.groupInfo.meta || "N/A"}
        />
        <PatientDetail
          title={tNs("physicianIconTooltip")}
          icon={<MedicalServices />}
          text={chatData.groupInfo.info?.physician?.[0]?.name || "TBD"}
        />
        <PatientDetail
          title={tNs("insuranceIconTooltip")}
          icon={<HealthAndSafety />}
          text={chatData.groupInfo.insurance || "TBD"}
        />
        <PendingReferralsDetail chatData={chatData} />
      </Box>
    </>
  );
};

export default PatientMoreContent;
